import { setJuridikaMediaUrl } from '~/utils/solr/juridika-media-config'

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const mediaUrl = config.public.juridikaMediaUrl

  if (!mediaUrl) {
    console.error(
      '[Juridika Media] NUXT_PUBLIC_JURIDIKA_MEDIA_URL is not configured. '
      + 'Images from Solr will not be displayed. '
      + 'Please set this environment variable in your .env file or deployment configuration.',
    )
    return
  }

  setJuridikaMediaUrl(mediaUrl)
})
